"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trim = void 0;

var _escapeRegExp = require("../escapeRegExp/escapeRegExp");

var _trim = function _trim() {
  var char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : " ";
  var source = arguments.length > 1 ? arguments[1] : undefined;
  var safeChar = (0, _escapeRegExp.escapeRegExp)(char);
  return source.replace(new RegExp("^[".concat(safeChar, "]+|[").concat(safeChar, "]+$"), "g"), "");
};
/**
 * Remove char from beginning and end of string
 *
 * @param {String} char   Character to be removed
 * @param {String} source Source string
 *
 * @return {String}
 *
 * @tag String
 * @signature (char: String) => (source: String): String
 * @signature (char: String, source: String): String
 *
 * @example
 * trim()(" lorem  ")
 * // => "lorem"
 *
 * trim("-", "-- lorem  -")
 * // => " lorem  "
 */


var trim = function trim() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  // @signature (char) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _trim(params[0], source);
    };
  } // @signature (char, source)


  return _trim.apply(void 0, params);
};

exports.trim = trim;